import { Component, OnInit, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChargeSelectorComponent } from './charge-selector/charge-selector.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MawbService } from 'src/app/shared/services/mawb.service';

interface ChargeData {
  selected: boolean;
  type_code: string;
  type_label: string;
  type_value: number;
}

@Component({
  selector: 'addtional-charges',
  templateUrl: './addtional-charges.component.html',
  styleUrls: ['./addtional-charges.component.css'],
})
export class AddtionalChargesComponent implements OnInit {
  chargesTemplate = [];
  constructor(
    readonly dialog: MatDialog,
    readonly configService: ConfigService,
    readonly mawbService: MawbService
  ) {}

  selectedCharges = [];
  data: any[];
  @Input()
  set setData(data: any) {
    this.configService.fetchConfig('additional_charges').then(res => {
      if (res.data) {
        this.chargesTemplate = res.data.map(d => {
          return {
            selected: false,
            type_code: d.code,
            type_label: d.label,
            type_value: 0,
          };
        });

        this.selectedCharges = (data || []).map(d => {
          return {
            selected: true,
            type_code: d.typeCode,
            type_value: d.value,
            type_label:
              this.chargesTemplate.find(r => r.type_code == d.typeCode)?.type_label || 'unknown',
          };
        });
      }
    });
  }
  get setData() {
    return this.selectedCharges;
  }
  _mawb: string;
  @Input()
  set mawb(id: string) {
    this._mawb = id;
  }
  get mawb() {
    return this._mawb;
  }

  _isClosed: boolean = true;
  @Input()
  set isClosed(b: boolean) {
    this._isClosed = b;
  }
  get isClosed() {
    return this._isClosed;
  }

  add() {
    const dialogRef = this.dialog.open(ChargeSelectorComponent, {
      autoFocus: false,
      maxHeight: '70vh',
      maxWidth: '60vw',
      data: {
        chargesSelected: this.selectedCharges,
        chargesData: this.chargesTemplate,
      },
    });
    dialogRef.afterClosed().subscribe(response => {
      this.selectedCharges = response.data;
      const payload = response.data.map(this.mapPayLoad);
      this.callService(this._mawb, payload);
    });
  }

  remove(charge: ChargeData): void {
    const index = this.selectedCharges.indexOf(charge);

    if (index >= 0) {
      this.selectedCharges.splice(index, 1);
      const payload = this.selectedCharges.map(this.mapPayLoad);
      this.callService(this._mawb, payload);
    }
  }
  mapPayLoad(d) {
    return {
      value: d.type_value,
      typeCode: d.type_code,
    };
  }
  callService(mawb, payload) {
    this.mawbService.updatemawbCharges(mawb, payload).subscribe(() => {});
  }
  initConfig() {
    this.configService.fetchConfig('additional_charges').then(res => {
      if (res.data) {
        this.chargesTemplate = res.data.map(d => {
          return {
            selected: false,
            type_code: d.code,
            type_label: d.label,
            type_value: 0,
          };
        });
      }
    });
  }
  ngOnInit(): void {
    this.initConfig();
  }
}
